import React from 'react';

type HelperTextProps = {
  id?: string;
  text: string;
};

function FormHelperText({ id, text }: HelperTextProps): JSX.Element {
  return (
    <span id={id} className="helper-text" aria-live="polite">
      {text}
    </span>
  );
}

export default FormHelperText;
